import React from 'react';
import PropTypes from 'prop-types';
import DatasetModel from '../../../../models/pipeline/steps/dataset';
import {inputBlurEvent, inputFocusEvent} from '../../../../services/query_builder_events';
import {queryBuilderState} from '../../../../services/query_builder_state';
import {MENUS} from '../../../../utils/query_utils';
import stopEvent from '../../../../utils/stop_event';
import ResultsTable from '../../../common/results_table';

function renderColumnHeader(dataset, column) {
    const attribute = dataset.getAttributeWithId(column.name);
    let menuButton = null;

    const onClick = stopEvent(() => {
        if (queryBuilderState.menu === MENUS.COMBINED_AGG) {
            inputBlurEvent.emit();
        } else {
            inputFocusEvent.emit(menuButton, MENUS.COMBINED_AGG, attribute, 'aggregation');
        }
    });

    return (
        <div>
            <button
                className="select-field"
                onClick={onClick}
                ref={(el) => { menuButton = el; }}
            >
                {attribute.aggregation.label}
            </button>
            <span className="column-name-header-text">
                {attribute.column.fullName}
            </span>
        </div>
    );
}

export default function ColumnFirstQueryResult({dataset, hasExecuted, onExecute,}) {
    const sampleTable = dataset.getSampleTable();
    if (sampleTable) {
        return (
            <div className="pipeline-step-body">
                <div className={`pipeline-step-results query-result-table ${hasExecuted ? '': 'sample'}`}>
                    <ResultsTable
                        step={dataset}
                        data={sampleTable.getSampleData(false)}
                        showGroups
                        zebraStripes={false}
                        showMenu={true}
                        limit={!hasExecuted ? 4 : undefined}
                        renderColumnHeader={column => renderColumnHeader(dataset, column)}
                        hasExecuted={hasExecuted}
                        onExecute={onExecute}
                    />
                    {hasExecuted || (
                        <div className="query-result-table-sample-execute-query">
                            <div className="query-result-table-sample-overlay">
                                <div className="query-result-table-sample-text">SAMPLE</div>
                            </div>
                            <button
                                className="button submit-button"
                                onClick={onExecute}
                            >
                                Execute Query
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }
    return null;
}

ColumnFirstQueryResult.propTypes = {
    dataset: PropTypes.instanceOf(DatasetModel).isRequired,
    hasExecuted: PropTypes.bool,
    onExecute: PropTypes.func.isRequired,
};

ColumnFirstQueryResult.defaultProps = {
    hasExecuted: false,
};
